import React from 'react';
import { Link } from 'react-router-dom';

import { downloadImage } from 'js/library/services/StorageManager.js';
import placeholder from 'styles/assets/placeholder/placeholder.gif';
import { trackEventMatomoElementId } from 'js/library/utils/helpers';

export const Establishment = (data) => {
  const [downloadedImage, setDownloadedImage] = React.useState(null);

  console.log(data);

  const func = data.func;
  const id = data.data.id;
  data = data.data;
  data.id = id;

  function downloadImageOnLoad() {
    if (data.fotoThumb !== undefined && downloadedImage === null) {
      downloadImage('estabelecimento', data.fotoThumb)
        .then((downloaded) => {
          setDownloadedImage(downloaded);
        })
        .catch((error) => {
          return error;
        });
    }
  }

  const descricao =
    data.descricao === undefined
      ? ''
      : data.descricao.length < 50
      ? data.descricao
      : data.descricao.substring(0, 50) + '...';

  return (
    <Link
      onClick={() => {
        func();
        trackEventMatomoElementId('Menu', 'tocar', 'lista', data.id);
      }}
      className="search-box"
      to={{ pathname: '/estabelecimento/', search: '?id=' + data.id, state: data[data.type] }}
    >
      <div className="search-box__thumb">
        <img
          src={downloadedImage === null ? placeholder : downloadedImage}
          onLoad={() => downloadImageOnLoad()}
          alt="busca"
        />
      </div>
      <div className="search-box__content">
        <h3>{data.nome}</h3>
        <p>{descricao}</p>
      </div>
    </Link>
  );
};

export default Establishment;
